import {
  ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_SUCCESS,
  ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_FAILED,
  RESET_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE,
  LOADING_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE,
  NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetadminTransferTypeMapppingCompare = () => {
  return { type: RESET_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE };
};

const adminTransferTypeMapppingCompare =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE });
    await adminServices
      .post("gettransferTypeMapping", userData, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch({
              type: ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_SUCCESS,
              payload: res.data,
            });
            break;
          default:
            dispatch({
              type: ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_FAILED,
              payload: res.data,
            });
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE,
          payload: err,
        });
      });
  };

export {
  adminTransferTypeMapppingCompare,
  resetadminTransferTypeMapppingCompare,
};
